import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.iKi9+h',
    defaultMessage: 'App collections',
  },
  description: {
    id: 'studio.MU09Un',
    defaultMessage: 'Browse collections of open-source apps',
  },
});
